import { render } from "./IconShowcase.vue?vue&type=template&id=e38e3e5a&scoped=true"
import script from "./IconShowcase.vue?vue&type=script&lang=js"
export * from "./IconShowcase.vue?vue&type=script&lang=js"

import "./IconShowcase.vue?vue&type=style&index=0&id=e38e3e5a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38e3e5a"]])

export default __exports__